
class AssetLoaderInfo {
    constructor(toLoadCount) {
        this.toLoadCount = toLoadCount;
        this.loadCount = 0;
        this.errors = [];
        this.loadedAssets = [];
        this.lastLoadedAssetId = "NONE";
        this.lastLoadedAssetStatus = AssetLoaderInfo.Status.None;

        this.onLoaded = function() { };
    }
}
AssetLoaderInfo.Status = {
    None: 0,
    Query: 1,
    Loaded: 2,
    Failed: 3
};

export default AssetLoaderInfo;
